import ErrorBoundary from "@deloitte-omnia/core-fe-mfe/ErrorBoundary";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import PropTypes from "prop-types";
import { Component } from "react";
import { getAppInsights } from "../../TelemetryServices";

class ErrorBoundaryComponent extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    let appInsights = getAppInsights();
    this.setState({ hasError: true });
    appInsights?.appInsights?.trackException({
      error: error,
      exception: error,
      severityLevel: SeverityLevel.Error,
      properties: { ...errorInfo },
    });
    //you can call the service to capture your error also
    if (this.props.captureError) this.props.captureError();
  }

  render() {
    if (this.state.hasError) {
      // eslint-disable-next-line react/react-in-jsx-scope
      return <ErrorBoundary>{this.props.children}</ErrorBoundary>;
    }
    return this.props.children;
  }
}

ErrorBoundaryComponent.propTypes = {
  captureError: PropTypes.func,
  children: PropTypes.any,
};

export default ErrorBoundaryComponent;
